import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import * as _ from 'lodash';
import Image from 'next/image';

import { JobTypeField } from 'modules/job-types/types';

import styles from './HomeRequestFormEntry.module.scss';

interface Props {
  firstField: JobTypeField;
  isOffset?: boolean;
  label: string;
  onSubmit: (propertyType: string) => void;
}

const HomeRequestFormEntry: FC<Props> = ({ firstField, label, isOffset, onSubmit }) => {
  const { t } = useTranslation();
  const optionValues = ['Built home', 'apartment', 'other'];
  const propertyTypeFieldOptions = _.keyBy(firstField.options, 'value');

  return (
    <div
      className={classNames(styles.container, {
        [styles['offset']]: isOffset,
      })}
    >
      <p className={styles.title}>{label}</p>
      <div className={styles.buttons}>
        {optionValues.map((val) => {
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          const curOption = propertyTypeFieldOptions[val] || {};
          const formattedVal = val.toLowerCase().replace(' ', '-');
          const isApartment = val === 'apartment';

          return (
            <button
              key={`form-entry-btn-${formattedVal}`}
              className={styles['form-entry-button']}
              onClick={() => onSubmit(val)}
            >
              <div className={classNames(styles.icon, { [styles['icon-apartment']]: isApartment })}>
                <Image
                  alt={curOption.label}
                  src={`/static/images/icons/property-${formattedVal}-icon.svg`}
                  layout="fill"
                />
              </div>
              {isApartment ? (
                <div
                  className={classNames(styles['form-entry-button-text'], styles['apartment-text'])}
                >
                  {t('marketingPages:homeRequestFormEntry.apartment')}
                  <div className={styles['sub-text']}>
                    {t('marketingPages:homeRequestFormEntry.apartmentExample')}
                  </div>
                </div>
              ) : (
                <div className={styles['form-entry-button-text']}>{curOption.label}</div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default HomeRequestFormEntry;
